import "./SuvaiMenu.scss"
import menu from "../../assets/images/menu.jpg"
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { fetchAllRestaurantMenuData, getAllData, getAvailableMenuItems, getAvailableMenus } from "../../../../../../../redux/resturantWidgetSlice";
import MenuItem from "../../components/MenuItem/MenuItem";
import Button from "../../components/button/Button";
const SuvaiMenu = () => {
    const company = useSelector((state) => state.companyData.company);
    const { menuData, defualtSelectedLocation, organizationID, } = useSelector((state) => state.resturantData);
    const [data, setData] = useState(null)
    const [itemsData, setItemsData] = useState(data)
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: company?.LocationID,
            OrganizationID: company?.OrganisationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);


    useEffect(() => {
        setIsLoading(true)
        fetchMenuData();

    }, []);
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);

        });
    }, [menuData]);
    useEffect(() => {
        if (data) {
            const menuDataObject = data
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };
            setCategories(filteredCategories);
            setItemsData(updatedData);
            setIsLoading(false)
        }

    }, [isLoading, data]);
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID));

        return items;
    }

    return (
        <div className="SuvaiMenu">
            <div className="SuvaiMenu-hero">
                <div className="SuvaiMenu-hero-imageCont"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(42, 42, 43, 0.18), rgba(42, 42, 43, 0.18)),
linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%) , url(${menu})`
                    }}>
                    <div className="SuvaiMenu-hero-imageCont-header">
                        The suvai fusion experience
                    </div>
                </div>
                <div className="SuvaiMenu-hero-textCont">
                    <div className="SuvaiMenu-hero-textCont-subheader">a la carte</div>
                    <div className="SuvaiMenu-hero-textCont-header">Menu</div>
                    <div className="SuvaiMenu-hero-textCont-content">We are passionate about sourcing fresh ingredients, combining
                        with traditional flavours and continually evolving our menu to create a dining experience that is truly unique.</div>
                </div>
            </div>
            <div className="SuvaiMenu-container">
                <div className="SuvaiMenu-container-inner">
                    <div className="SuvaiMenu-container-inner-menu">

                        {categories?.map((category) => {
                            return (
                                <MenuItem
                                    items={
                                        getCatgoryItems(category.MenuEntities)
                                    }
                                    headerText={category?.Title?.en}
                                />)
                        })}</div>
                    <Button
                        text={"Order Now"}
                        type="SECONDARY"
                        onClick={() => {
                            window.open("", '_blank')
                        }} />

                </div>
            </div>
        </div>
    )
}
export default SuvaiMenu
